import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

export const CacheInvalidator = () => {
  const [isInvalidating, setIsInvalidating] = useState(false);
  const { toast } = useToast();

  const handleInvalidate = async () => {
    setIsInvalidating(true);
    
    try {
      const { data, error } = await supabase.functions.invoke('invalidate-cache', {
        body: {}
      });

      if (error) throw error;

      toast({
        title: "Cache Invalidated",
        description: `Successfully purged ${data?.urls?.length || 0} URLs from Cloudflare cache.`,
      });
    } catch (error) {
      console.error('Cache invalidation error:', error);
      toast({
        title: "Error",
        description: "Failed to invalidate cache. Check console for details.",
        variant: "destructive",
      });
    } finally {
      setIsInvalidating(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cache Invalidation</CardTitle>
        <CardDescription>
          Purge Cloudflare CDN cache for explore pages, business listings, and sitemap.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button 
          onClick={handleInvalidate} 
          disabled={isInvalidating}
          className="w-full"
        >
          {isInvalidating ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Invalidating Cache...
            </>
          ) : (
            "Invalidate Cache"
          )}
        </Button>
      </CardContent>
    </Card>
  );
};
